module.exports = __webpack_public_path__ + "img/detail-call.0bf82daa.svg";